import React from 'react';

import rachaelRayShowImage from '@images_responsive/home/partnerships/rachael_ray_show.jpg';

import { BaseCard } from './base_card';
import { SizedResponsiveImage } from './sized_responsive_image';

export const RachaelRayShowCard: React.FC = () => (
  <BaseCard
    heading="Rachael Ray Show"
    subheading="Daytime TVs sweetheart, Rachael Ray, chooses Clutter to help her and her guests"
    container="rachael_ray_show"
    media={
      <SizedResponsiveImage
        image={rachaelRayShowImage}
        alt="Daytime TVs sweetheart, Rachael Ray, chooses Clutter to help her and her guests"
      />
    }
    body={
      <>
        Rachael Ray chose Clutter to be featured on upcoming episodes of the
        Rachael Ray Show. Keep an eye on daytime TVs favorite home-everything
        host to see why Clutter is the obvious choice to help you with your
        storage and moving needs.
      </>
    }
  />
);
